<template>
  <div class="experts">
    <Nav activeNav="experts"></Nav>

    <div class="container">
      <div class="sider">
        <div class="label">专家库</div>

        <el-input
          placeholder=""
          size="small"
          v-model="keyword"
          class="input-with-select"
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="toSearch"
          ></el-button>
        </el-input>

        <ul class="options">
          <li
            :class="[
              'option',
              {
                'option-active': type === item.value
              }
            ]"
            v-for="item in typeOptions"
            :key="item.value"
            @click="type = item.value"
          >
            {{ item.label }}
          </li>
        </ul>
      </div>

      <div class="main">
        <!-- <div class="top-title">专家列表</div> -->

        <div class="label">全部</div>

        <ul v-if="list.length">
          <li v-for="item in list" :key="item.id" @click="toDetail(item)">
            <div class="show">
              <img class="img" :src="item.photoUrl" :alt="item.photoUrl" />
            </div>
            <div class="content">
              <h3 class="title">{{ item.name }}</h3>
            </div>
          </li>
        </ul>
        <el-empty v-else description="暂无数据"></el-empty>

        <el-pagination
          background
          class="pagination"
          layout="prev, pager, next"
          :total="total"
          :page-size="pageSize"
          @current-change="currentChange"
        ></el-pagination>
      </div>
    </div>

    <el-dialog title="" :visible.sync="dialogVisible" width="50%">
      <div class="detail" v-if="item">
        <img class="detail-avatar" :src="item.photoUrl" :alt="item.photoUrl" />
        <div class="detail-info">
          <div class="detail-top">
            <h3 class="detail-title">{{ item.name }}</h3>
            <p class="detail-label">
              {{ item.type == 1 ? '推荐专家' : '普通专家' }}
            </p>
          </div>
          <div class="detail-middle">
            <p class="detail-institutionPosition">
              {{ item.institutionPosition }}
            </p>
            <p class="detail-expertise">{{ item.expertise }}</p>
          </div>
          <p class="detail-introduction">{{ item.introduction }}</p>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Nav from '../event/coms/nav'

export default {
  components: {
    Nav
  },
  data() {
    return {
      keyword: '',
      typeOptions: [
        {
          label: '全部专家',
          value: '0'
        },
        {
          label: '普通专家',
          value: '2'
        },
        {
          label: '推荐专家',
          value: '1'
        }
      ],
      type: '0',
      dialogVisible: false,
      eventList: [],
      eventTotal: 0,
      eventCurrent: 1,
      eventPageSize: 10,
      loading: true,
      jsId: this.$route.params.jsId,
      detail: null,
      list: [],
      pageSize: 5,
      current: 1,
      total: 0,
      item: null
    }
  },
  async mounted() {
    if (!this.jsId) {
      this.jsId = await this.fetchJsRecordList()
    }
    this.fetchJsExpertStoreList()
  },
  watch: {
    type() {
      this.fetchJsExpertStoreList()
    }
  },
  methods: {
    toSearch() {
      this.fetchJsExpertStoreList()
    },
    async fetchJsRecordList(pageIndex = 1) {
      const [err, res] = await this.$serve.jsRecord.getPageList({
        data: { pageIndex }
      })
      if (err) return
      this.eventList = res.records
      this.eventTotal = res.total
      this.eventCurrent = res.pageIndex
      this.eventPageSize = res.pageSize
      return this.eventList[0].id
    },
    async fetchJsExpertStoreList(pageIndex = 1) {
      const [err, res] = await this.$serve.jsExpertStore.getPageList({
        data: {
          pageIndex,
          pageSize: 10,
          jsId: this.jsId,
          keyword: this.keyword,
          type: this.type === '0' ? '' : this.type
        }
      })
      if (err) return
      this.list = res.records
      this.pageSize = res.pageSize
      this.current = res.pageIndex
      this.total = res.total
    },
    currentChange(pageIndex) {
      this.fetchJsExpertStoreList(pageIndex)
    },
    toDetail(item) {
      this.item = item
      this.dialogVisible = true
    }
  }
}
</script>

<style scoped lang="scss">
.experts {
  padding-bottom: 40px;

  .container {
    max-width: 1320px;
    margin: 0 auto;
    padding: 40px 0 20px 0;
    display: flex;
    gap: 30px;
  }

  .sider {
    width: 200px;
    // padding: 66.8px 0 0;
    flex-shrink: 0;
  }

  .options {
    margin: 30px 0;
  }

  .option {
    cursor: pointer;
  }

  .option + .option {
    margin-top: 10px;
  }

  .option-active {
    color: rgb(209, 183, 104);
  }

  .main {
    flex: 1;
  }

  .top-title {
    text-align: center;
    color: rgb(209, 183, 104);
    font-weight: 600;
    font-size: 32px;
    margin-bottom: 30px;
  }

  .label {
    border-bottom: 1px solid #000;
    margin-bottom: 40px;
    padding-bottom: 30px;
    font-size: 24px;
  }

  ul {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(256px, 1fr));
    gap: 20px;
  }

  li {
    cursor: pointer;
    // border: 2px solid #b6b6b6;
    overflow: hidden;
  }

  .show {
    width: 100%;
    padding-top: 120%;
    position: relative;
    overflow: hidden;
  }

  .img {
    position: absolute;
    width: 100%;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    background: #f5f5f5;
  }

  .content {
    padding: 10px;
    line-height: 1.5;
  }

  .title {
    margin: 4px 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .pagination {
    margin-top: 20px;
    text-align: center;
  }

  .detail {
    display: flex;
    align-items: center;
    gap: 40px;
    padding: 0 10px 0 0;
  }

  .detail-avatar {
    width: 45%;
    flex-shrink: 0;
  }

  .detail-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #999;
    padding-bottom: 2px;
  }

  .detail-title {
    color: rgb(209, 183, 104);
  }

  .detail-label {
    padding: 4px 6px;
    border: 1px solid #000;
    color: #000;
  }

  .detail-middle {
    width: 100%;
    display: flex;
    gap: 40px;
    margin: 16px 0 10px;
  }

  .detail-introduction {
    line-height: 1.5;
  }
}
</style>
